<template>
  <VDialogV3
    id="unit-card"
    position="right"
    width="600px"
    height="100vh"
    :entity="localUnit"
    :context-menu="localUnit?.isExisting === true ? UnitsService.contextMenu : null"
    :submit-method="submit"
  >
    <section>
      <VInput
        v-model="localUnit.nameFull"
        label="Полное название единицы измерения"
        layout="vertical"
        required
        :max-length="150"
      />

      <VInput
        v-model="localUnit.name"
        label="Сокращенное название единицы измерения"
        layout="vertical"
        required
        :max-length="30"
      />

      <VInput
        v-model="localUnit.code"
        label="Код по ОКЕИ"
        layout="vertical"
        :validate-method="validateCode"
      />

      <VInputNumberRusV2
        v-model="localUnit.qtyMultiplier"
        :type="QtyMultiplier"
        label="Множитель количества"
        layout="vertical"
        required
      />
    </section>
  </VDialogV3>
</template>

<script lang="ts">

import Unit               from '@/domains/Units/Unit';
import UnitsService       from '@/domains/Units/UnitsService';
import QtyMultiplier         from "@/core/types/QtyMultiplier";

export default defineComponent({
  name: 'UnitCard',

  props: {
    id: {
      type:    Number,
      default: null,
    },
  },

  data() {
    return {
      localUnit: null as Unit | null,
    };
  },

  setup() {
    return {
      QtyMultiplier,
      UnitsService,
    }
  },

  async mounted() {
    await this.init();
  },

  methods: {
    async init(): Promise<void> {
      if (this.id) {
        this.localUnit = await UnitsService.get(this.id);
      }
      else {
        this.localUnit = new Unit();
      }
    },

    async submit(): Promise<boolean> {
      if (this.localUnit.isExisting === true) {
        return await UnitsService.update(this.localUnit);
      }
      else {
        return await UnitsService.add(this.localUnit);
      }
    },

    // ==================== Валидация ====================

    validateCode(value: string): string | null {
      if (!value) return null;

      const parsedValue = Number(value);
      if (!Number.isInteger(parsedValue)) return 'Число должно быть целым';
      if (parsedValue < 1 || parsedValue > 32767) return 'Число должно быть между 0 и 32767';
      return null;
    },
  },
});
</script>